// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2aczf","savePackageButton":"ClientWallet_savePackageButton__gUU2I"};